export default __webpack_public_path__ + "static/media/ins.745e6c64.png";